import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { IProjectActivity, IProjectActivityAddDataset } from '../../projectDetailsActivities.models';

export const AddDatasetActivity = ({ values }: IProjectActivity<IProjectActivityAddDataset>): ReactElement => {
  const { t } = useTranslator();
  return (
    <span>
      {t('activity_description_AddDataset')}
      <b>{values.name}</b>.
    </span>
  );
};
